import * as api from "Api";
import * as actions from "Actions";

export const fetchPresentation = (target, period) => {
  return (dispatch, getState) => {
    let owner = null;
    if (getState().auth.currentOrganization) {
      const { uen } = getState().auth.currentOrganization;
      owner = uen;
    }

    const { token } = getState().auth;

    dispatch(
      actions.fetchPresentation(
        api
          .getPresentation({
            target: target,
            owner: owner,
            token,
            period
          })
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const fetchPresentationUsers = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    let organizationId = currentOrganization.id;

    return dispatch(
      actions.fetchPresentationUsers(
        api.getUsersSettings("", "", organizationId)
      )
    );
  };
};

export const savePresentation = (target, period, dashboard, isFrozen) => (
  dispatch,
  getState
) => {
  const {
    presentation: {
      presentationConfig: {
        id,
        date,
        isPrepared,
        isPresented,
        presenters,
        thankingSlide,
        questionsSlide,
        extraSlides,
        hiddenSlides
      }
    },
    auth: {
      currentOrganization: { uen }
    }
  } = getState();

  return dispatch(
    actions.savePresentation(
      api.savePresentation({
        id,
        owner: uen,
        target,
        dashboard,
        date,
        isPrepared,
        isPresented,
        isFrozen,
        presenters: presenters.map(user => user.id),
        thankingSlide,
        questionsSlide,
        extraSlides,
        hiddenSlides,
        period
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/presentation.js